export default __webpack_public_path__ + "static/media/kuakata.1f159219.png";